import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getSubscription = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/member/subscription'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberHccId: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Members.GetSubscription", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlan.Members.GetSubscription.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getListOfMembers = (token, memId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/members/list'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Members.GetMembersList", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlan.Members.GetMembersList.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getMemberProfile = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/members/profile'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Members.GetMembersProfile", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.Members.GetMembersProfile.Failure", start, url, err); return Promise.reject(err);
    });
};

export const updateMemberAddress = (token, memid, email, address1, address2, city, state, zip, phone) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/member/address'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            AppliesToAddressTypes: ["Home", "Mailing"],
            AppliesToMembers: [memid],
            AddressInfo: {
                Type: "Mailing",
                EmailAddress: email,
                AddressLine1: address1,
                AddressLine2: address2,
                City: city,
                State: state,
                ZipCode: zip,
                Telephones: phone ? [{
                    PhoneType: "Home",
                    AreaCode: phone.length > 3 ? phone.substring(0, 3) : null,
                    Number: phone
                }] : []
            }
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Members.UpdateMemberAddress", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(params);
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.Members.UpdateMemberAddress.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getCorrespondenceEmailAddress = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/member/getCorrespondenceEmailAddress'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberId: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Members.GetCorrespondenceEmailAddress", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.Members.GetCorrespondenceEmailAddress.Failure", start, url, err); return Promise.reject(err);
    });
};